import React, { useState } from 'react';
import * as Yup from 'yup'; // Import Yup directly
import { useFormik } from 'formik';
import clsx from 'clsx';
import { t } from 'i18next';
import { subscribe } from '../core/subscribe/requests';

const Newsletter = () => {
    const [loading, setLoading] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const initialValues = {
        email: '',
    };

    const newsletterSchema = Yup.object().shape({
        email: Yup.string()
            .email('Wrong email format')
            .min(3, 'Minimum 3 symbols')
            .max(50, 'Maximum 50 symbols')
            .required('Email is required'),
    });

    const handleSubmit = async (values: any, formikBag: any) => {
        formikBag.setSubmitting(true);
        try {
            setLoading(true);
            await subscribe(values);
            setLoading(false);
            setIsActive(true);
            formikBag.resetForm();
            setTimeout(() => {
                setIsActive(false);
            }, 2500);
        } catch (ex) {
            console.error(ex);
        } finally {
            formikBag.setSubmitting(false);
            setLoading(false);
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema: newsletterSchema,
        onSubmit: handleSubmit,
    });

    return (
        <div className={'container carbon-page'}>
            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 text-center'}>
                    <div className={' bg-light-opacity bdr-21'}>
                        <div className={'pt-lg-5 ps-2 pe-2 pt-3 pb-1'}>
                            <div className={`ff-main-title-semi primary-text fs-20`}>
                                Join our community. Receive the latest on Garden of Life.
                            </div>
                        </div>
                        {isActive && (
                            <div className={'row justify-content-center'}>
                                <div className={'col-lg-9'}>
                                    <div className="alert alert-success fade show  text-start">
                                        {t('alert.success')}
                                    </div>
                                </div>
                            </div>
                        )}
                        <form className="form w-100 pb-lg-5 ps-2 pe-2 pb-4" onSubmit={formik.handleSubmit} noValidate>
                            <div className={'form-group row justify-content-center'}>
                                <div className={'col-lg-6 col-12 mt-2'}>
                                    <input
                                        type={'email'}
                                        {...formik.getFieldProps('email')}
                                        placeholder={t('form.subscribe.placeholder') || ''}
                                        className={clsx('form-control main-input rounded', {
                                            'is-invalid': formik.touched.email && formik.errors.email,
                                        })}
                                    />
                                    {formik.touched.email && formik.errors.email && (
                                        <div className="invalid-feedback">{formik.errors.email}</div>
                                    )}
                                </div>
                                <div className={'col-lg-3 col-7 mt-2'}>
                                    <button className="btn btn-primary-dark w-100" disabled={formik.isSubmitting || !formik.isValid} type="submit">
                                        {!loading && <span className="indicator-label">{t('buttons.subscribe')}</span>}
                                        {loading && (
                                            <span className="indicator-progress" style={{ display: 'block' }}>
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Newsletter;
